<template>
  <div class="text-red">
    <WebhusetLogo
      src="/Webhuset-logo.svg"
      alt="Webhuset logo"
      v-if="config.public.companyProfileId === 1"
    />
    <ServerbiteLogo
      src="/Serverbite-logo.svg"
      alt="Serverbite logo"
      v-else-if="config.public.companyProfileId === 4"
      class="h-8"
    />
  </div>
</template>

<script lang="ts" setup>
import WebhusetLogo from "@/public/Webhuset-logo.svg?component";
import ServerbiteLogo from "@/public/Serverbite-logo.svg?component";
const config = useRuntimeConfig();
</script>

<style></style>
